import React, { useEffect } from 'react';
import { node, string } from 'prop-types';
import { Helmet } from 'react-helmet-async';

const Metadata = (props) => {
  const { title, children } = props;
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('metadata.ready'); }, []);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      { children }
    </>
  );
};

Metadata.propTypes = {
  children: node,
  title: string
};

Metadata.defaultProps = {
  children: null,
  title: null
};

export { Metadata };
